/**
 * Convert just english digits to persian
 * @author Khalili
 * @param String $text
 * @returns String
 */
export const toEnDigits = (text) => {
  let persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  let arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  if (typeof text === "string") {
    for (var i = 0; i < 10; i++) {
      text = text.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return text;
};
